export default `{
  "premium_proxies": true,
  "country": "gb"
}`
